import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import {
  FaBook,
  FaChevronDown,
  FaChevronUp,
  FaComments,
  FaExclamationCircle,
  FaLifeRing,
  FaQuestionCircle,
  FaThLarge,
  FaTicketAlt,
} from 'react-icons/fa';
import { ADMIN_ROUTES, adminPath } from '../../constants/adminPortal';

const BASE = adminPath(ADMIN_ROUTES.SUPPORT_MANAGEMENT);

const NAV = [
  { to: `${BASE}/dashboard`, end: true, label: 'Support Dashboard', icon: FaThLarge },
  { to: `${BASE}/tickets`, label: 'Tickets', icon: FaTicketAlt },
  { to: `${BASE}/reported-issues`, label: 'Reported Issues', icon: FaExclamationCircle },
  { to: `${BASE}/faq-management`, label: 'FAQ Management', icon: FaQuestionCircle },
  { to: `${BASE}/live-chat`, label: 'Live Chat Requests', icon: FaComments },
  { to: `${BASE}/knowledge-base`, label: 'Knowledge Base', icon: FaBook },
];

export default function SupportManagementLayout() {
  const [centerOpen, setCenterOpen] = useState(true);

  return (
    <div className="support-mgmt-layout">
      <aside className="support-mgmt-layout__sidebar" aria-label="Support center">
        <div className="support-mgmt-layout__brand">
          {/* <p className="support-mgmt-layout__brand-title">WorkForce Admin</p>
          <p className="support-mgmt-layout__brand-sub">Support Management</p> */}
        </div>

        <nav className="support-mgmt-layout__nav">
          <button
            type="button"
            className="support-mgmt-layout__nav-heading"
            onClick={() => setCenterOpen(!centerOpen)}
            aria-expanded={centerOpen}
          >
            <span className="support-mgmt-layout__nav-heading-inner">
              <FaLifeRing aria-hidden className="support-mgmt-layout__nav-heading-icon" />
              Support Center
            </span>
            {centerOpen ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
          </button>
          {centerOpen && (
            <div className="support-mgmt-layout__nav-list">
              {NAV.map(({ to, label, icon: Icon, end }) => (
                <NavLink
                  key={to}
                  to={to}
                  className={({ isActive }) =>
                    `support-mgmt-layout__link${isActive ? ' support-mgmt-layout__link--active' : ''}`
                  }
                  end={Boolean(end)}
                >
                  <Icon aria-hidden className="support-mgmt-layout__link-icon" />
                  {label}
                </NavLink>
              ))}
            </div>
          )}
        </nav>
      </aside>

      <div className="support-mgmt-layout__main">
        <div className="support-mgmt-layout__main-inner">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
